import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

export interface MonitoringErrorNoticeProps {
  message: string;
  onRetry: () => void;
}

// Shared inline error state for the dashboard's three independent queries
// (filter options, CE roster, dashboard metrics) — each can fail on its own,
// so each renders this instead of an endless spinner or a silent empty state.
const MonitoringErrorNotice = ({
  message,
  onRetry,
}: MonitoringErrorNoticeProps) => (
  <div className="flex flex-col items-center justify-center gap-2 p-5 bg-navy-50 rounded-lg">
    <Icons.Warning className="size-7 text-critical-500" aria-hidden="true" />
    <p className="font-semibold text-gray-700">{message}</p>
    <Button variant="reserve-outlined" size="sm" onClick={onRetry}>
      Retry
    </Button>
  </div>
);

export default MonitoringErrorNotice;
